import ecRetention from '../../consts/experienceScore/ecRetention';
import helpers from '../../utils/helpers';
import storageService from '../storageService';

const isExpired = (createdAt) => !createdAt || Date.now() - createdAt > ecRetention.FLOW_MS;

const getFlowId = () => {
    const flow = storageService.getEcFlow();

    if (!flow?.id) return null;

    if (isExpired(flow.createdAt)) {
        storageService.removeEcFlow();

        return null;
    }

    return flow.id;
};

const startFlow = (flowId) => {
    const activeFlowId = getFlowId();

    if (activeFlowId) return activeFlowId;

    const id = flowId || helpers.guid();

    storageService.setEcFlow({id, createdAt: Date.now()});

    return id;
};

const endFlow = () => storageService.removeEcFlow();

export default {
    getFlowId,
    startFlow,
    endFlow,
};
